<ng-container *ngIf="permissionData$| async as permissionData">
  <div *ngIf="purchaseType === 'rfq' || purchaseType === 'corporatecard'">
    <mat-slide-toggle (change)="onToggleChange($event)" [checked]="isRFSEnabled && !isReferenced"
      [disabled]="!isRFSChangable || !isCOTS || isReferenced" class="custom-toggle">
      <p class="rfs-toggle-title paragraph-large-medium">Request for sourcing
        <ng-template #tooltipTemplateInfo>
          <div class="custom-tooltip">
            <p>Enable this option to request Purchasing Department for sourcing.</p>
          </div>
        </ng-template>
        <mat-icon class="custom-tooltip-help-icon" [tp]="tooltipTemplateInfo" tpMaxWidth="300px" [tpInteractive]="true"
          tpPlacement="bottom">help</mat-icon>
      </p>
    </mat-slide-toggle>
    <div class="rfs-msg paragraph-medium-regular">
      This option allows purchasing executives to source vendors for your intended item purchases. Opting out of this
      service after document submission is not allowed. <br>
      It is enabled by default when: <br>
      1. Your items consists of <b>only Commercial-off-the-shelf products.</b><br>
      2. Your purchase amount <b>exceeds SGD 6,000.</b>
    </div>
  </div>

  <div *ngIf="isSOWStageError">
    <shared-alert [type]="alertType.Error">
      <p alert-content class="my-1">At least 2 vendors is required for competitive tender.</p>
    </shared-alert>
  </div>

  <div class="advisory-msg">
    <p class="paragraph-large-medium">Conflict of Interest Advisory</p>
    <p class="subTitle paragraph-medium-medium">Definition of interest</p>
    <ng-container *ngFor="let msg of advisoryMsgs">
      <p class="mar-btm-5 paragraph-medium-regular">{{ msg.value }}</p>
    </ng-container>
    <p class="subTitle paragraph-medium-medium">Warning</p>
    <p class="mb-1" class="paragraph-medium-regular">{{ warningMsg }}</p>
    <div *ngIf="PDPItems">
      <shared-alert [type]="alertType.Info">
        <p alert-content class="my-1">Due to Project PDP’s governing factor, you are required to buy from ACL/ASL for
          the
          following item no.: <strong>{{PDPItems}}</strong></p>
      </shared-alert>
    </div>
  </div>
  <app-add-reference-card desc="You have not added any vendor." btnLabel="+ Add vendor"
    (btnClickHandler)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')) && normalVendorOpen()"
    btngit btnLabelTwo="Recommended ACL/ASL"
    (recAclAslHandler)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc)) && aslVendorOpen()"
    [hasExtraButton]="true" *ngIf="vendorDataSource.data.length < 1" [disabled]="isLocked">
  </app-add-reference-card>

  <app-button class="budgetBtn" icon="add" name="Add vendor" type="flat-button" tabindex="0" [disabled]="isLocked || isWocApproved"
    (keypress)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')) && !isLocked && !isWocApproved && normalVendorOpen()"
    (click)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')) && !isLocked && !isWocApproved && normalVendorOpen()"
    *ngIf="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')) && vendorDataSource.data.length > 0">
  </app-button>
  <app-button class="acslBtn" icon="recommend" name="Recommend ACL/ASL" type="flat-button" tabindex="0" [disabled]="isLocked"
    (keypress)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')) && !isLocked && aslVendorOpen()"
    (click)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')) && !isLocked && aslVendorOpen()"
    *ngIf="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')) && vendorDataSource.data.length > 0">
  </app-button>
  <app-button
      class="mx-2"
      [ngClass]="{'acslBtn':!(isDocReadOnly && isComponentReadOnly && !permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection') || !vendorDataSource.data.length || !isVselected()), 'button-padding': isDocReadOnly && isComponentReadOnly && !permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection') || !vendorDataSource.data.length || !isVselected()}"
      icon="delete" name="Remove vendor" type="flat-button" tabindex="0"
      [disabled]="isDocReadOnly && isComponentReadOnly && !permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection') || isLocked || !vendorDataSource.data.length || !isVselected() || isWocApproved"
      (keypress)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection')) && !isLocked  && !isWocApproved && removeVSelectedRows()"
      (click)="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection')) && !isLocked && !isWocApproved && removeVSelectedRows()"
      *ngIf="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection')) && vendorDataSource.data.length > 0">
  </app-button>
  <div class="mt-2">
    <div class="custom-table-wrapper--inner" *ngIf="vendorDataSource.data.length > 0">
      <table mat-table [dataSource]="vendorDataSource" class="mat-elevation-z8 data-grid-table">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="vSelect">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterVToggle() : null"
              [checked]="rowSelection.hasValue() && isAllVSelected()"
              [indeterminate]="rowSelection.hasValue() && !isAllVSelected()"
              *ngIf="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection')) && !isLocked && !isWocApproved">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" [ngClass]="{ 'selected-color': rowSelection.isSelected(row)}">
            <mat-checkbox tabindex="0" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()"
              [disabled]="row.isDeleted || row.Strikethrough" (change)="onCheckboxChange($event, row)"
              [checked]="rowSelection.isSelected(row)"
              *ngIf="(!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection')) && !isLocked && !isWocApproved">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container *ngFor="let column of vendorColumns">
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'Name'">
            <th mat-header-cell *matHeaderCellDef>Vendor name</th>
            <td mat-cell *matCellDef="let row"
              [ngClass]="{'deleted-row': row.isDeleted || row.Strikethrough, 'selected-color': rowSelection.isSelected(row) }">

              {{ column.cell(row) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'VendorContactPerson'">
            <th mat-header-cell *matHeaderCellDef>Contact person</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="{ 'selected-color': rowSelection.isSelected(element), 'deleted-row': element.isDeleted || element.Strikethrough }">
              {{ column.cell(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'VendorNumber'">
            <th mat-header-cell *matHeaderCellDef>Vendor no.</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="{ 'selected-color': rowSelection.isSelected(element), 'deleted-row': element.isDeleted || element.Strikethrough}">
              {{ column.cell(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'AddressCountryCode'">
            <th mat-header-cell *matHeaderCellDef>Country</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="{ 'selected-color': rowSelection.isSelected(element), 'deleted-row': element.isDeleted || element.Strikethrough}">
              {{ column.cell(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'EmailAddress'">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="{ 'selected-color': rowSelection.isSelected(element), 'deleted-row': element.isDeleted || element.Strikethrough}">
              {{ column.cell(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'VendorStatus'">
            <th mat-header-cell *matHeaderCellDef>Vendor status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="{ 'selected-color': rowSelection.isSelected(element), 'deleted-row': element.isDeleted || element.Strikethrough}">
              {{ column.cell(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'VendorType'">
            <th mat-header-cell *matHeaderCellDef>Vendor type</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="{ 'selected-color': rowSelection.isSelected(element), 'deleted-row': element.isDeleted || element.Strikethrough}">
              {{ column.cell(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="
              column.columnDef == 'Justification' && (purchaseType === 'tender' || purchaseType === 'dc')
            ">
            <th mat-header-cell *matHeaderCellDef>Justification</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="{ 'selected-color': rowSelection.isSelected(element) ,'deleted-row': element.isDeleted || element.Strikethrough}">
              {{ column.cell(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column.columnDef }}" *ngIf="column.columnDef == 'rowActions'">
            
            <th mat-header-cell *matHeaderCellDef class="table-cell--freeze-right">Action</th>

            <td mat-cell *matCellDef="let row" class="table-cell--freeze-right custom-table-icon-buttons" [ngClass]="{ 'selected-color': rowSelection.isSelected(row)}">
              <button (click)="!row.isDeleted && !row.Strikethrough && editVendorOpen(row)"
                *ngIf="!isDocReadOnly || !isComponentReadOnly || isVendorOnlyEditable || permissionData.ability.can('update',permissionData.formWoc, 'vendor-selection')"
                [disabled]="isLocked"
                type="button">
                <mat-icon title="Edit">edit</mat-icon>
              </button>
              <button (click)="!row.isDeleted && !row.Strikethrough && removeSelectedRow(row)"
                *ngIf="!isDocReadOnly || !isComponentReadOnly || permissionData.ability.can('delete',permissionData.formWoc, 'vendor-selection')"
                [disabled]="isLocked || isWocApproved"
                type="button">
                <mat-icon title="Delete">delete</mat-icon>
              </button>
            </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="vendorDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: vendorDisplayedColumns" [ngClass]="{'custom-table-row--disabled': row.isDeleted || row.Strikethrough }"></tr>
      </table>
    </div>
    <mat-paginator class="custom-table-paginator" #vendorPg [length]="vendorDataSource.data.length" showFirstLastButtons
      [pageSizeOptions]="pageSizeOptions"></mat-paginator>
  </div>
  <div class="rfq-deadline" *ngIf="purchaseType === 'rfq'">
    <p class="paragraph-medium-regular">
      RFQ deadline is
      <input #rfqdeadline class="test" type="number" [min]="7" [(ngModel)]="rfqDeadline"
        (ngModelChange)="onChangeRFQDeadline($event)" name="rfqDeadline" (input)="restrictNegativeNumberInput($event)"
        [readonly]="isDocReadOnly && !isRFQDeadlineEditable && !permissionData.ability.can('update',permissionData.formDeadline)"
        [disabled]="isDocReadOnly && !isRFQDeadlineEditable && !permissionData.ability.can('update',permissionData.formDeadline)" />
      calendar days after RFQ released date.
    </p>
    <p class="paragraph-medium-regular">
      Please take note that RFQ closure date must be minimum 7 days after RFQ released date.
    </p>
  </div>
  <div
    *ngIf="((vendorDataSource.data.length > 1 && containsOneVendor) || (vendorDataSource.data && vendorDataSource.data.length === 1)) && recieved > 6000 && (!isRFSEnabled || isReferenced)"
    class="woc-section">
    <div class="paragraph-large-medium">Waiver of Competition</div>

    <div class="woc-description">
      <mat-hint style="font-size: 14px" class="paragraph-small-regular">Required in situations where we only select one vendor and the estimated total
        item amount is S$6,000 and above.</mat-hint>
    </div>
    <form class="woc-form" [formGroup]="wocForm">
      <p class="paragraph-medium-regular">Reason *</p>
      <mat-form-field>
        <mat-select formControlName="WOCReason" [disabled]="isDocReadOnly" (selectionChange)="onSelectReason($event)">
        <mat-select-trigger>
          <span class="red" *ngIf="selectedWoCReason">
            {{ selectedWoCReason.content }}
          </span>
        </mat-select-trigger>
          <mat-option *ngFor="let reason of wocReasons" [value]="reason.id">
            <div class="woc-option">
              <div>{{ reason.content }}</div>

              <mat-icon *ngIf="showTooltips(reason)" class="woc-icon custom-tooltip-help-icon"
                tpClassName="custom-tooltip" tp="{{ reason.tooltips }}" tpMaxWidth="300px" [tpInteractive]="true"
                tpPlacement="right" aria-valuetext="help">help</mat-icon>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="
            displayWocNotRequiredForWorkflowMessage(selectedWoCReason)
          " class="container woc-info">
        <mat-icon class="icon">info</mat-icon>
        <div>
          WOC not required for the workflow.
        </div>
      </div>
      <div *ngIf="
            displayBlanketApprovalMessage(selectedWoCReason)
          " class="container woc-info">
        <mat-icon class="icon">info</mat-icon>
        <div>
          Reason selected has been granted blanket approval. Document will not
          be routed for WOC approval.
        </div>
      </div>
      <div *ngIf="
                    hasFile()
                  ">
        <p class="paragraph-medium-regular">File reference *</p>
        <mat-form-field>
          <mat-select formControlName="FileReferenceNumber" [disabled]="isDocReadOnly">
            <mat-option *ngFor="let file of fileReferences" [value]="file.Code">
              {{ file.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <p class="paragraph-medium-regular">Justification *</p>
      <mat-form-field>
        <textarea class="woc-justification" [(ngModel)]="elaborateWoCReason" formControlName="WOCJustification"
        maxlength="1500" required matInput [disabled]="isDocReadOnly"
          placeholder="e.g. The vendor selected offers a unique product or service that cannot be found elsewhere.">
          </textarea>
        <mat-hint align="end">{{ characterCount }}/1500</mat-hint>
      </mat-form-field>
      <mat-icon tp="{{ tooltipInfoWOC }}" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true"
        tpPlacement="bottom">help</mat-icon>
    </form>
  </div>
  <div *ngIf="purchaseType === 'dc' && canShowDotpSection()"
    class="woc-section">
    <div class="paragraph-large-medium">Dispensation of Tendering Procedure</div>
    <div class="woc-description">
      <mat-hint class="paragraph-small-regular">Required when in a single source situation (above S$200,000), and where there
        is merit to do away with a formal Tender.</mat-hint>
    </div>
    <form class="woc-form" [formGroup]="dotpForm">
      <p class="paragraph-medium-regular">Reason *</p>
      <mat-form-field>
        <mat-select formControlName="DOTPReason" [disabled]="isDocReadOnly" (selectionChange)="onSelectDOTPReason($event)">
          <mat-option *ngFor="let reason of dotpReasons" [value]="reason.id">
            <div class="woc-option">
              <div>{{ reason.Reason }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="isOthersSelected">


        <p class="paragraph-medium-regular">Remarks *</p>
        <mat-form-field>

          <textarea formControlName="DOTPRemarks" class="dotp-remarks" [(ngModel)]="elaborateDoTPRemarks"
          name="elaborateDoTPRemarks" maxlength="1500" required matInput [disabled]="isDocReadOnly">
              </textarea>
          <mat-hint align="end">{{ dotpRemarksCharacterCount }}/1500</mat-hint>
        </mat-form-field>
      </div>
      <p class="paragraph-medium-regular">Justification *</p>
      <mat-form-field>
        <textarea formControlName="DOTPJustification" class="dotp-justification" [(ngModel)]="elaborateDoTPReason"
        name="elaborateDoTPReason" maxlength="1500" required matInput [disabled]="isDocReadOnly"
          placeholder="e.g. The long term strategic partnership with Company X." (input)="onTextChange($event)">
              </textarea>
        <mat-hint align="end">{{ dotpCharacterCount }}/1500</mat-hint>
      </mat-form-field>
      <mat-icon tp="{{ tooltipInfoDOTP }}" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true"
        tpPlacement="bottom">help</mat-icon>
    </form>
  </div>
  <app-tender-date-time-form *ngIf="purchaseType === 'tender'"
    [isReadOnly]="isCE && !permissionData.ability.can('update',permissionData.formTenderValidity)"></app-tender-date-time-form>
</ng-container>